module.exports = __webpack_public_path__ + "img/118.2770da3f.jpg";